import { IOrganisationalUnit } from '../interfaces/IJob';
import { ODOO_INST_TYPE } from './constants';

export const isCeeEnabled = (typeInstallation: string, hasCee: boolean) => {
    return typeInstallation === ODOO_INST_TYPE.NEW && hasCee;
};

export const isQuoteSigned = (photoList: string[]) => {
    return photoList.filter((photo) => photo.includes('_QSIG_')).length > 0;
};

export const isSocialHousing = (organisationalUnit: IOrganisationalUnit) => {
    return 'shCee' in organisationalUnit[2]
        ? organisationalUnit[2].shCee
        : false;
};
